import VistaprintAuth from "@vp/auth"
import { BOOKEND_TYPES, BookendsMetaTag, Footer, Header } from "@vp/esi-bookends"
import { latestPricingContextModuleUrl } from "@vp/pricing-context-module/cdn"
import pricingContextModuleHelpers from "@vp/pricing-context-module/helpers"
import { BoundedContent, Box, MainContentStart, SiteContent, SiteMain } from "@vp/swan"
import * as React from "react"
import { Helmet } from "react-helmet"
import { SwanConfiguration } from "./SwanConfiguration"

import { buildAnalyticsMetaDataFor } from "./Analytics/trackingConfiguration"
import { Seo } from "./Seo"

const StaticPagesLayout = (props) => {
  const [authLibrary, setAuthLibrary] = React.useState(null)

  React.useEffect(() => {
    const authConfig = {
      culture: props.locale,
    }

    if (process.env.GATSBY_AUTH_CONNECTION) {
      authConfig.options = {
        connection: process.env.GATSBY_AUTH_CONNECTION,
      }
    }

    if (process.env.GATSBY_AUTH_DEVELOPMENT_MODE_CLIENT_ID) {
      authConfig.developmentMode = {
        clientID: process.env.GATSBY_AUTH_DEVELOPMENT_MODE_CLIENT_ID,
        redirectUriOrigin: process.env.GATSBY_AUTH_CALLBACK_URL ? process.env.GATSBY_AUTH_CALLBACK_URL : window.location.origin,
      }
    } else {
      authConfig.developmentMode = process.env.GATSBY_DEVELOPMENT_MODE ? true : false
    }

    VistaprintAuth.init(authConfig, () => {
      const authLibrary = new VistaprintAuth.WebAuth()
      setAuthLibrary(authLibrary)
    })
  }, [props.locale])

  const { availability, pageSeo, isProdEnvironment } = props

  React.useEffect(() => {
    const isAuthInitialized = !!authLibrary

    if (isAuthInitialized) {
      const country = props.locale.split(/-|_/)[1].toUpperCase()
      const isDevelopment = process.env.NODE_ENV === "development" || process.env.GATSBY_DEVELOPMENT_MODE
      const pricingContextConfig = {
        merchantId: process.env.GATSBY_TENANT,
        market: country,
        isDevelopmentMode: isDevelopment,
      }
      pricingContextModuleHelpers.initializePricingContext(pricingContextConfig)
    }
  }, [props.locale, authLibrary])

  return (
    <SwanConfiguration tenant={process.env.GATSBY_TENANT} locale={props.locale}>
      <BookendsMetaTag
        renderWith={Helmet}
        locale={props.locale}
        tenant={process.env.GATSBY_TENANT}
        headerType={BOOKEND_TYPES.FULL}
        footerType={BOOKEND_TYPES.FULL}
      />
      <Helmet defer={false}>
        <script src={latestPricingContextModuleUrl}></script>
      </Helmet>
      <SiteContent>
        <Seo
          metaRobot={getMetarobot({ seo: pageSeo, availability, isProdEnvironment })}
          canonicalUrl={pageSeo?.canonicalUrl}
          metaDescription={pageSeo?.metaDescription}
          metaTitle={pageSeo?.metaTitle}
        />
        <div id="header-padding" />
        <Header
          locale={props.locale}
          tenant={process.env.GATSBY_TENANT}
          type={BOOKEND_TYPES.FULL}
          trackingConfiguration={buildAnalyticsMetaDataFor(props.trackingData)}
        />
        <SiteMain>
          <MainContentStart />
          <Box pt={"5"} pb={"7"}>
            <BoundedContent>{props.children}</BoundedContent>
          </Box>
        </SiteMain>
        <Footer
          locale={props.locale}
          tenant={process.env.GATSBY_TENANT}
          type={BOOKEND_TYPES.FULL}
          trackingConfiguration={buildAnalyticsMetaDataFor(props.trackingData)}
        />
      </SiteContent>
    </SwanConfiguration>
  )
}

const getMetarobot = ({ seo, availability, isProdEnvironment }) => {
  if (isProdEnvironment && availability === "Public") {
    return (seo || {}).metaRobot || "index,follow"
  }

  return "noindex,follow"
}

export default StaticPagesLayout
